import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ObservationTypeDialogData} from '../../../../../../shared/models/observation-type';
import {MatInput} from '@angular/material/input';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-update-observation-type-dialog',
  templateUrl: 'update-observation-type-dialog.component.html',
  styleUrls: ['update-observation-type-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ]
})
export class UpdateObservationTypeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<UpdateObservationTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObservationTypeDialogData) {}
}
